var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IntersectionObserver',{class:_vm.css.root,attrs:{"options":{
    rootMargin: '0px 0px 100%',
  }},on:{"intersect":_vm.handleIntersect}},[_c('div',{class:("infox_" + _vm.currentId)}),_vm._v(" "),_c('transition',{attrs:{"name":"fade"}},[(!_vm.state.isRendered)?_c('div',{class:_vm.css.loader},[_c('MicroLoader',{attrs:{"theme":"light"}})],1):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }